(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trWidget', trWidget);

  function trWidget(bsLoadingOverlayService) {
    const directive = {
      restrict: 'E',
      transclude: {
        'headerExtra': '?headerExtra',
        'titleExtra': '?titleExtra',
        'headerIcon': '?headerIcon'
      },
      scope: {
        widgetTitle: '@',
        settings: '&',
        icon: '@',
        showLoader: '@',
        samePageTitle: '&',
        showPanel: '&',
        headerCollapse: '&',
        onHeaderClick: '&',
        widgetHolderClass: '@',
        widgetTitleCustomClass: '@'
      },
      templateUrl: '/scripts/shared/directives/widget/widget.partial.html',
      compile: compile
    };

    return directive;

    function compile () {
      return {
        post: function (scope) {
          if(scope.showLoader) {
            bsLoadingOverlayService.start();
          }
          scope._handleHeaderClick = function (event) {
            if (typeof scope.onHeaderClick === 'function' && event.currentTarget.className === 'widget_header_content') {
              scope.onHeaderClick({$event:event});
            }
          };
        }
      };
    }


  }
})();
